module.exports = __webpack_public_path__ + "static/media/emo2a.6f6077da.png";